import React from 'react'
import {Spinner} from './Spinner.styles'

export const SpinnerComponent = () => {
  return (
    <Spinner />
  )
}
